import { PHONE_NUMBER_MASK } from '@exam-center/utils';
import IMask from 'imask';
import { z } from 'zod';

const MAX_EMAIL_LENGTH = 256;
const MAX_ADDRESS_LENGTH = 1024;

export const ExamCenterProctorDetailsSchema = z.object({
  personal: z.object({
    email: z
      .string()
      .trim()
      .email({ message: 'รูปแบบอีเมลผู้ใช้ไม่ถูกต้อง' })
      .max(MAX_EMAIL_LENGTH, `ความยาวต้องไม่เกิน ${MAX_EMAIL_LENGTH} ตัวอักษร`)
      .optional(),
    phoneNumber: z
      .string()
      .nullish()
      .refine(
        (val) => {
          if (!val) return true;
          const mask = IMask.createMask({ mask: PHONE_NUMBER_MASK });
          mask.resolve(val);
          return mask.isComplete;
        },
        { message: 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง' },
      ),
    address: z
      .string()
      .trim()
      .max(MAX_ADDRESS_LENGTH, `ความยาวต้องไม่เกิน ${MAX_ADDRESS_LENGTH} ตัวอักษร`),
  }),
  employeeInfo: z.object({
    code: z.string().trim().nullish(),
    position: z.string().trim().nullish(),
    department: z.string().trim().nullish(),
  }),
});

export type ExamCenterProctorDetailsFormInput = z.infer<typeof ExamCenterProctorDetailsSchema>;
